import { Job, User, OutputType, ProcessType } from '../JmReact';
import TableIDs from '../data/TableIDs.js';
import { encodeXml } from "../utils/utils.js";
import { message } from "antd";

/**
 * Centralized item-code resolution for document line entry.
 * @param {object} ctx - TableContainer instance (this)
 * @param {string} itemCode
 * @param {object} options
 * @param {'fill'|'add'|'merge'} options.mode
 * @param {Function} [options.callback]
 * @param {object} [options.baseRecord]
 * @param {boolean} [options.isSumFlag]
 */
export function processItemCode(ctx, itemCode, options = {}) {
    const {
        mode = 'fill',
        callback = null,
        baseRecord = null,
        isSumFlag = false,
    } = options;

    if (!itemCode) return;

    const record = baseRecord || ctx.props.data.document2.editedRecord;
    const val = itemCode;
    const _supplier = ctx.props.data.document2.filterItemsPerSupplier == '1'
        ? ctx.props.data.document2.supplierCode
        : '0';
    const dataSend = "_itemCode\f_isWithMatrix\f_isWithFather\f_supplier\r" + val + "\f1\f1\f" + _supplier;
    const user = new User(ctx.props.user.token, ctx.props.user.companyCode);
    const job = new Job(user, 'check_all_item_code_per_supplier', OutputType["OUTPUT_TYPE_DATA"], ProcessType["PROCESS_TYPE_SYNC"]);
    job.setInput(dataSend);
    job.send("/cgi-bin/CashOnTab",
        (ob) => {
            let responseArr = null;
            if (ob.data === "") {
                responseArr = [];
            } else {
                responseArr = (ob.data).split('\r');
            }

            const isNegativeQtyDoc = () => [21, 22, 222, 9].find(f => f == ctx.props.documentType);
            const defaultQty = () => (isNegativeQtyDoc() ? -1 : 1);

            const saveOrFillError = (errorRecord) => {
                if (mode === 'fill') {
                    ctx.onEditedRecordChange(errorRecord, callback);
                } else {
                    ctx.saveEditedRecord(errorRecord);
                }
            };

            if (responseArr.length > 1) {
                if (mode !== 'fill') {
                    saveOrFillError({
                        ...record,
                        itemCode: itemCode,
                        description: "-ברקוד אינו פריט יחודי-",
                        quantity: isNegativeQtyDoc() ? -1.00 : 1.00,
                        isValid: 0,
                        unitPriceWithTax: 0.00,
                        discountPercentage: 0.00,
                        totalSumWithTax: 0.00,
                    });
                    return;
                } else {
                    responseArr = responseArr[0];
                }
            }

            if (responseArr.length === 0) {
                if (mode === 'fill') {
                    ctx.onEditedRecordChange({
                        ...record,
                        itemCode: val,
                        itemBarcode: '',
                        description: '',
                        quantity: defaultQty(),
                        isValid: 0,
                        unitPriceWithTax: 0.00,
                        discountPercentage: 0.00,
                        totalSumWithTax: 0.00,
                    }, callback);
                    ctx.props.uiActions.showModal(TableIDs.SelectorItemsModal, {});
                } else {
                    saveOrFillError({
                        ...record,
                        itemCode: itemCode,
                        description: "-פריט לא קיים-",
                        quantity: isNegativeQtyDoc() ? -1.00 : 1.00,
                        isValid: 0,
                        unitPriceWithTax: 0.00,
                        discountPercentage: 0.00,
                        totalSumWithTax: 0.00,
                    });
                }
                return;
            }

            const resArr = responseArr[0].split('\f');
            const _ItemCode = resArr[1];
            const _ItemName = resArr[2];
            const _IsMatrix = resArr[3];
            const _IsMatrixFather = resArr[4];
            const _ItemBarCode = resArr[5];
            const _ItemSize1ID = resArr[6];
            const _Size1Desc = resArr[8];
            const _ColorDesc = resArr[9];
            const _UOM_Qty = resArr[12];

            let _IsValid = (mode === 'fill')
                ? ((ctx.props.data.document2.dataSource.filter(i => i.itemCode === _ItemCode && i.isValid == 1 && i.isSerialize == '0').length) ? 5 : parseInt(resArr[13]))
                : ((ctx.props.data.document2.dataSource.filter(i => i.itemCode === _ItemCode && i.isValid == 1).length) ? 5 : parseInt(resArr[13]));
            console.log('resArr', resArr, _IsValid)

            if (!_ItemCode) {
                if (mode === 'fill') {
                    ctx.onEditedRecordChange({
                        ...record,
                        itemCode: val,
                        itemBarcode: _ItemBarCode,
                        description: _ItemName,
                        quantity: defaultQty(),
                        isValid: 0,
                        unitPriceWithTax: 0.00,
                        discountPercentage: 0.00,
                        totalSumWithTax: 0.00,
                    }, callback);
                    ctx.props.uiActions.showModal(TableIDs.SelectorItemsModal, {});
                } else {
                    saveOrFillError({
                        ...record,
                        itemCode: itemCode,
                        description: "-פריט לא קיים-",
                        quantity: isNegativeQtyDoc() ? -1.00 : 1.00,
                        isValid: 0,
                        unitPriceWithTax: 0.00,
                        discountPercentage: 0.00,
                        totalSumWithTax: 0.00,
                    });
                }
                return;
            }

            if (_IsMatrixFather === '1' && !ctx.props.fatherItemInDoc) {
                if (mode === 'fill') {
                    const modalParamObj = { ...ctx.props.ui.data, mCode: _ItemCode };
                    ctx.props.uiActions.showModal(TableIDs.modalMatrixQuantities, modalParamObj);
                } else {
                    saveOrFillError({
                        ...record,
                        itemCode: itemCode,
                        description: "-פריט אב-",
                        quantity: isNegativeQtyDoc() ? -1.00 : 1.00,
                        isValid: 0,
                        unitPriceWithTax: 0.00,
                        discountPercentage: 0.00,
                        totalSumWithTax: 0.00,
                    });
                }
                return;
            }

            ctx.getUOMSizesRuler(_ItemCode);

            const buildBonusCalcData = (metaResArr) => {
                if (!ctx.props.config.isUnitCost) return undefined;
                return {
                    mBaseCost: metaResArr[16],
                    mSupDscnt1: metaResArr[17],
                    mSupDscnt2: metaResArr[18],
                    mSupDscnt3: metaResArr[19],
                    mCostIncludeDscnt: metaResArr[20],
                    mBonusQty: metaResArr[21],
                    mQtyForBonusQty: metaResArr[22],
                    mCostIncludeBonus: metaResArr[23],
                };
            };

            const fetchAndDispatchItemLineMeta = () => {
                const isSupp = [4, 16, 17, 18].find(f => f == ctx.props.documentType) ? true : false;
                const metaDataSend = "_itemCode\f_customerId\f_supplierId\f_priceListId\f_posId\f_docTime\f_docType\r" +
                    [_ItemCode,
                        ctx.props.data.document2.customerCode,
                        isSupp ? ctx.props.data.document2.supplierCode : "",
                        ctx.props.data.document2.priceListId,
                        ctx.props.posId,
                        ctx.props.data.document2.docDateTime,
                        ctx.props.documentType
                    ].join("\f");

                const metaUser = new User(ctx.props.user.token, ctx.props.user.companyCode);
                const metaJob = new Job(metaUser, "get_item_line_meta", OutputType["OUTPUT_TYPE_DATA"], ProcessType["PROCESS_TYPE_SYNC"]);
                metaJob.setInput(metaDataSend);
                metaJob.send("/cgi-bin/CashOnTab", (metaOb) => {
                    const metaResArr = (metaOb.data).split('\f');
                    let _unitCost = metaResArr[0];
                    let _price = metaResArr[1];
                    let _unitCostNoTax = metaResArr[2];
                    let _priceNoTax = metaResArr[3];
                    const _taxId = metaResArr[4];
                    let _taxPercentageValue = metaResArr[5];
                    const _supplierId = metaResArr[6];
                    const _isSerialize = metaResArr[7];
                    const _isWeightable = metaResArr[8];

                    if (ctx.props.config.isUnitCost) {
                        if ((ctx.props.costCalcOption == '1' || ctx.props.costCalcOption == '2') && metaResArr[20]) {
                            if (mode === 'fill') {
                                _unitCostNoTax = metaResArr[20];
                                _unitCost = _unitCostNoTax * ((parseFloat(_taxPercentageValue) + 100) / 100);
                            } else {
                                _priceNoTax = metaResArr[20];
                                _price = _priceNoTax * ((parseFloat(_taxPercentageValue) + 100) / 100);
                            }
                        } else if (mode !== 'fill') {
                            _price = _unitCost;
                            _priceNoTax = _unitCostNoTax;
                        }
                    }

                    if ((ctx.props.hidePrices && (ctx.props.documentType == '15' || ctx.props.documentType == '215'))
                        || (ctx.props.typePriceTransfers == 0 && ctx.props.documentType == '5051')) {
                        _unitCost = 0;
                        _price = 0;
                        _unitCostNoTax = 0;
                        _priceNoTax = 0;
                    }

                    if (ctx.props.typePriceTransfers == 2 && ctx.props.documentType == '5051') {
                        _price = _unitCost;
                        _priceNoTax = _unitCostNoTax;
                    }

                    const customerDiscount = metaResArr[25] > 0
                        ? metaResArr[25]
                        : (ctx.props.data.document2.customerDiscount ? ctx.props.data.document2.customerDiscount : 0);

                    if (metaResArr[26] > 0) _IsValid = 6;

                    let _remarks = '';
                    if (parseInt(_IsMatrix, 10) === 1) {
                        _remarks = encodeXml(_remarks, 'Color', _ColorDesc);
                        _remarks = encodeXml(_remarks, 'Size1', _Size1Desc);
                    }
                    if (metaResArr[24]) {
                        _remarks += metaResArr[24];
                    } else if (mode === 'fill') {
                        const prevRemarks = ctx.getXmlValue(record.remarks).value;
                        if (prevRemarks) _remarks += prevRemarks;
                    }

                    let _q;
                    let _uq;
                    let _fq;
                    let unitQuantity;
                    let unitDescription;

                    if (mode === 'fill') {
                        _uq = _UOM_Qty * 1.00;
                        _fq = isNegativeQtyDoc() ? -1 : 1;
                        _q = _fq * _uq;
                        unitQuantity = _fq;
                        unitDescription = ctx.getSizeDescription(_ItemSize1ID);
                    } else {
                        _q = _UOM_Qty * 1.00;
                        if (isNegativeQtyDoc()) _q = _q * -1;
                        _uq = _q;
                        unitQuantity = 1.00;
                        unitDescription = (_Size1Desc) ? _Size1Desc : '';
                    }

                    let costCurrencyId = null;
                    let costCurrencySymbol = null;
                    let costCurrencyValue = null;
                    let costCurrencyRate = null;
                    const isEnglishDoc = [202, 203, 208, 215, 219, 222, 230].find(f => f == ctx.props.documentType);

                    if (isEnglishDoc) {
                        costCurrencyId = ctx.props.data.document2.currencyCode;
                        costCurrencySymbol = ctx.props.data.document2.currencySymbol;
                        costCurrencyRate = ctx.props.data.document2.currencyRate;
                    }

                    let unitPriceWithTax;
                    let unitPriceNoTax;

                    if (ctx.props.config.isUnitCost) {
                        if (isEnglishDoc) {
                            costCurrencyValue = parseFloat((_unitCostNoTax ? _unitCostNoTax : 0) / (costCurrencyRate ? costCurrencyRate : 0)).toFixed(2);
                        } else if (mode === 'fill') {
                            costCurrencyId = metaResArr[10];
                            costCurrencySymbol = metaResArr[11];
                            costCurrencyValue = metaResArr[12];
                            costCurrencyRate = metaResArr[13];
                        }
                        unitPriceWithTax = parseFloat(_unitCost).toFixed(2);
                        unitPriceNoTax = parseFloat(_unitCostNoTax).toFixed(4);
                    } else {
                        if (isEnglishDoc) {
                            _price = _priceNoTax;
                            costCurrencyValue = parseFloat((_priceNoTax ? _priceNoTax : 0) / (costCurrencyRate ? costCurrencyRate : 0)).toFixed(2);
                        }
                        unitPriceWithTax = parseFloat(_price).toFixed(2);
                        unitPriceNoTax = parseFloat(_priceNoTax).toFixed(4);
                    }

                    const bonusCalcData = buildBonusCalcData(metaResArr);

                    const lineRecord = {
                        ...record,
                        itemCode: _ItemCode,
                        itemBarcode: _ItemBarCode,
                        description: _ItemName,
                        isValid: _IsValid,
                        unitPriceWithTax,
                        unitPriceNoTax,
                        discountPercentage: customerDiscount,
                        taxId: _taxId,
                        taxPercentageValue: parseFloat(_taxPercentageValue),
                        remarks: _remarks,
                        unitID: _ItemSize1ID,
                        quantityInUnit: mode === 'fill' ? (_UOM_Qty * 1.00) : _uq,
                        unitQuantity,
                        unitDescription,
                        isWeightable: _isWeightable,
                        isSerialize: _isSerialize,
                        cost: parseFloat(_unitCostNoTax).toFixed(2),
                        supplierId: _supplierId,
                        costCurrencyId: mode === 'fill' ? costCurrencyId : (metaResArr[10] || costCurrencyId),
                        costCurrencySymbol: mode === 'fill' ? costCurrencySymbol : (metaResArr[11] || costCurrencySymbol),
                        costCurrencyValue: mode === 'fill' ? costCurrencyValue : (metaResArr[12] || costCurrencyValue),
                        costCurrencyRate: mode === 'fill' ? costCurrencyRate : (metaResArr[13] || costCurrencyRate),
                        ...(bonusCalcData ? { bonusCalcData } : {}),
                    };

                    if (mode === 'fill') {
                        lineRecord.quantity = _q;
                        lineRecord.totalSumWithTax = (parseFloat(unitPriceWithTax) * _q * (1 - customerDiscount / 100)).toFixed(2);
                        lineRecord.totalSumNoTax = (parseFloat(unitPriceNoTax) * _q * (1 - customerDiscount / 100)).toFixed(4);
                        ctx.onEditedRecordChange(lineRecord, callback);
                        setTimeout(() => { ctx.setState({ disabledAddItem: false }); }, 100);
                    } else if (mode === 'merge' && isSumFlag === true && (_isSerialize ?? '0') == '0') {
                        const last_record = [...ctx.props.data.document2.dataSource]
                            .reverse()
                            .find(i => (
                                (i.itemCode === _ItemCode)
                                && (parseFloat(i.discountPercentage) === 0.00)
                                && (parseFloat(i.unitPriceWithTax) === parseFloat(unitPriceWithTax))
                                && (parseInt((i.unitID) ? i.unitID : 0) === parseInt((_ItemSize1ID) ? _ItemSize1ID : 0))
                            ));

                        if (last_record) {
                            ctx.updateRecordUsingData({
                                ...last_record,
                                quantity: parseFloat(last_record.quantity) + 1.00 * _q,
                                unitPriceWithTax,
                                unitPriceNoTax,
                                totalSumWithTax: (parseFloat(unitPriceWithTax) * (parseFloat(last_record.quantity) + _q) * (1 - parseFloat(last_record.discountPercentage) / 100)).toFixed(2),
                                totalSumNoTax: (parseFloat(unitPriceNoTax) * (parseFloat(last_record.quantity) + _q) * (1 - parseFloat(last_record.discountPercentage) / 100)).toFixed(4),
                                taxId: _taxId,
                                taxPercentageValue: parseFloat(_taxPercentageValue),
                                remarks: _remarks,
                                unitQuantity: parseFloat(last_record.unitQuantity) + 1.00,
                                isWeightable: _isWeightable,
                                isSerialize: _isSerialize,
                                cost: parseFloat(_unitCostNoTax).toFixed(2),
                                supplierId: _supplierId,
                                costCurrencyId: metaResArr[10],
                                costCurrencySymbol: metaResArr[11],
                                costCurrencyValue: metaResArr[12],
                                costCurrencyRate: metaResArr[13],
                                ...(bonusCalcData ? { bonusCalcData } : {}),
                            });
                        } else {
                            lineRecord.quantity = 1.00 * _q;
                            lineRecord.totalSumWithTax = (parseFloat(unitPriceWithTax) * _q * (1 - customerDiscount / 100)).toFixed(2);
                            lineRecord.totalSumNoTax = (parseFloat(unitPriceNoTax) * _q * (1 - customerDiscount / 100)).toFixed(4);
                            ctx.saveEditedRecord(lineRecord);
                        }
                    } else {
                        lineRecord.quantity = _q;
                        lineRecord.totalSumWithTax = (parseFloat(unitPriceWithTax) * _q * (1 - customerDiscount / 100)).toFixed(2);
                        lineRecord.totalSumNoTax = (parseFloat(unitPriceNoTax) * _q * (1 - customerDiscount / 100)).toFixed(4);
                        ctx.saveEditedRecord(lineRecord);
                    }
                }, () => {
                    message.error('שגיאה לא ידועה');
                });
            };

            if (mode === 'fill') {
                const isSaleDoc = [1, 2, 8, 9, 22, 2005, 202, 222].filter(f => f == ctx.props.documentType).length > 0;
                ctx.props.sendAPI("get_connected_items", "mCode\r" + _ItemCode, ob => {
                    const fData = ob.data.split("\r");
                    const hData = fData[0] ? fData[0].split("\f") : [];
                    const data = fData.slice(1, -1).map(x => {
                        const y = x.split("\f");
                        let obj = {};
                        hData.forEach((z, i) => { obj = { ...obj, [z]: y[i] }; });
                        if (!isSaleDoc || !parseFloat(obj.mSonPrice)) obj = { ...obj, priceToUpdate: true };
                        return obj;
                    });

                    if (data.length > 0) {
                        const addConnectedItems = () => {
                            const { parents } = ctx.state.modalAddConnectedItems ?? { parents: [] };
                            const { supplierCode, priceListId, dataSource, customerDiscount } = ctx.props.data.document2;
                            let lastKey = dataSource.length;
                            let allAddItems = [];

                            parents.forEach(parent => {
                                if (parent.type > 0) {
                                    const itemList = parent.type == 1 ? [
                                        { mSonItem: parent.parentCode, mSonBarcode: parent.parentBarcode, mSonDesc: parent.parentName, mSonQty: 1, mSonPrice: 0, priceToUpdate: true },
                                        ...parent.children
                                    ] : parent.children;
                                    const currentOffset = allAddItems.length;
                                    const mapped = itemList.map((x, i) => ({
                                        key: lastKey + currentOffset + i + 1,
                                        keyVal: lastKey + currentOffset + i + 1,
                                        itemCode: x.mSonItem,
                                        itemBarcode: x.mSonBarcode,
                                        description: x.mSonDesc,
                                        quantity: x.mSonQty,
                                        unitPriceWithTax: x.mSonPrice,
                                        discountPercentage: customerDiscount,
                                        totalSumWithTax: parseFloat(x.mSonPrice) && parseFloat(x.mSonQty) ? (parseFloat(x.mSonPrice) * parseFloat(x.mSonQty)).toFixed(2) : "0.00",
                                        remarks: "",
                                        unitID: 0,
                                        quantityInUnit: 1,
                                        unitQuantity: 1,
                                        unitDescription: '',
                                        isWeightable: 0,
                                        priceToUpdate: x.priceToUpdate
                                    }));
                                    allAddItems = [...allAddItems, ...mapped];
                                } else {
                                    parent.getItemLineMeta();
                                }
                            });

                            if (allAddItems.length > 0) {
                                ctx.props.updatePricesPerSupplier(supplierCode, priceListId, [...dataSource, ...allAddItems], null, true, lastKey, true);

                                const emptyRecord = {
                                    key: 0,
                                    keyVal: 0,
                                    itemCode: '',
                                    itemBarcode: '',
                                    description: '',
                                    quantity: 0.00,
                                    unitPriceWithTax: 0.00,
                                    discountPercentage: 0.00,
                                    totalSumWithTax: 0.00,
                                    unitID: 0,
                                    quantityInUnit: 0,
                                    unitQuantity: 0.00,
                                    unitDescription: '',
                                    isWeightable: 0,
                                };

                                ctx.props.dataActions.setJson("document2", { editedRecord: emptyRecord });
                                setTimeout(() => {
                                    document.getElementById("search_item_input_id").focus();
                                }, 2000);
                            }

                            setTimeout(() => {
                                ctx.setState({ modalAddConnectedItems: null });
                            }, 1000);
                        };

                        const parentEntry = {
                            parentCode: _ItemCode,
                            parentName: _ItemName,
                            parentBarcode: _ItemBarCode,
                            children: data,
                            type: isSaleDoc && data[0].mTypeToSales ? data[0].mTypeToSales : (!isSaleDoc && data[0].mTypeToPurchase ? data[0].mTypeToPurchase : "0"),
                            getItemLineMeta: fetchAndDispatchItemLineMeta,
                        };
                        const shouldAutoProcess = isSaleDoc ? !!data[0].mTypeToSales : !!data[0].mTypeToPurchase;
                        if (shouldAutoProcess) {
                            ctx.setState({ modalAddConnectedItems: { parents: [parentEntry], notViewModal: true } }, addConnectedItems);
                        } else {
                            const existing = ctx.state.modalAddConnectedItems;
                            const parents = (existing && !existing.notViewModal)
                                ? [...existing.parents, parentEntry]
                                : [parentEntry];
                            ctx.setState({ modalAddConnectedItems: { parents, addConnectedItems } });
                        }
                    } else {
                        fetchAndDispatchItemLineMeta();
                    }
                });
            } else {
                fetchAndDispatchItemLineMeta();
            }
        },
        () => {
            message.error('שגיאה לא ידועה');
        }
    );
}
